import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { AuditTrialDetails } from '../../shared/models/audits/audit-trial-details';
import { MessageService } from 'primeng/api';
import { SharedConstants } from '../../shared/constants/shared-constants';

@Component({
  selector: 'app-scope-audit-trial',
  templateUrl: './scope-audit-trial.component.html',
  styleUrls: ['./scope-audit-trial.component.scss']
})
export class ScopeAuditTrialComponent implements OnInit, OnChanges {
  @Input() auditTrailData: AuditTrialDetails[] = [];
  
  auditAttributeDetailsOfTransaction!: AuditTrialDetails;
  scopeAuditSummaryDetails: AuditTrialDetails[] = [];
  isDataLoaded = false;

  constructor(private messageService: MessageService) {}

  ngOnInit(): void {
    this.initializeAuditData();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['auditTrailData']) {
      this.initializeAuditData();
    }
  }

  private initializeAuditData(): void {
    if (this.auditTrailData && this.auditTrailData.length > 0) {
      this.scopeAuditSummaryDetails = this.auditTrailData;
      this.auditAttributeDetailsOfTransaction = this.auditTrailData[0];
      this.isDataLoaded = true;
      this.notifyMissingAttributesIfAny();
    } else {
      this.scopeAuditSummaryDetails = [];
      this.isDataLoaded = false;
    }
  }

  showAuditItemDetails(auditAttributeDetails: AuditTrialDetails) {
    this.auditAttributeDetailsOfTransaction = auditAttributeDetails;
  }

  private hasMissingAttributes(): boolean {
    return !!this.scopeAuditSummaryDetails?.some(d => d?.attributeDetails?.some(a => a?.isAttributeValueMissing));
  }

  private notifyMissingAttributesIfAny(): void {
    if (this.hasMissingAttributes()) {
      this.messageService.add({
        severity: SharedConstants.Severity_Warning,
        summary: SharedConstants.AuditTrail_AttributeMissing_Message,
        life: 20000,
      });
    }
  }
}
